<template>
	<v-parallax :height="$vuetify.breakpoint.mdAndUp ? 175 : 125" :src="image">
		<v-row align="center" justify="center">
			<v-col
				cols="12"
				md="10"
				class="d-flex align-center justify-space-between"
			>
				<div class="d-flex align-center">
					<!-- <v-btn
						fab
						v-if="showBackButton || $vuetify.breakpoint.smAndDown"
						class="mr-4 elevation-3"
						@click="$router.go(-1)"
					>
						<v-icon>
							mdi-arrow-left
						</v-icon>
					</v-btn> -->

					<div class="d-flex flex-column">
						<div
							class="d-flex justify-space-between align-center flex-wrap"
						>
							<slot>
								<h1 class="display-1 font-weight-thin">
									<slot name="title" class=""></slot>
								</h1>
							</slot>
						</div>

						<span class="subtitle">
							<slot name="subtitle"></slot>
						</span>
					</div>
				</div>

				<slot name="menu"></slot>
			</v-col>
		</v-row>
	</v-parallax>
</template>

<script>
export default {
	name: "TilteParallax",

	props: {
		image: {
			type: String,
			required: false,
			default:"/img/baners/323232r34re.jpg",
		},
	},

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped>
/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 1264px) {
	.title {
	}

	.subtitle {
	}
}
</style>
